<template>
  <div class="cpnt-cad-vis-dados" v-if="dados !== null">
    <!-- CONTATO -->
    <template v-if="cpntTipo === 'contato'">
      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 150px);"
        :cpntTitulo="'Nome'"
        :cpntValor="dados.nome"
        :cpntCopiar="cpntTipo + '--' + 'nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 150px;"
        :cpntTitulo="'Tipo Pessoa'"
        :cpntValor="(dados.pessoa === 'j' ? 'Pessoa Jurídica' : ((dados.pessoa === 'f' ? 'Pessoa Física' : 'Estrangeiro')))"
        :cpntCopiar="cpntTipo + '--' + 'pessoa'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template :style="$store.state.mobile !== true ? 'width: calc(100% - 150px - 150px - 150px);' : ''"  v-if="dados.pessoa === 'j'"
        :cpntTitulo="'Nome Fantasia'"
        :cpntValor="dados.empresa"
        :cpntCopiar="cpntTipo + '--' + 'empresa'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template v-if="dados.pessoa === 'e'" style="width: 200px;"
        :cpntTitulo="'ID Extrangeiro'"
        :cpntValor="dados.cnpj_cpf"
        :cpntCopiar="cpntTipo + '--' + 'cnpj_cpf'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template v-else :style="dados.pessoa === 'j' ? 'width: 150px;' : 'width: 50%'"
        :cpntTitulo="dados.pessoa === 'j' ? 'CNPJ' : 'CPF'"
        :cpntValor="dados.cnpj_cpf"
        :cpntCopiar="cpntTipo + '--' + 'cnpj_cpf'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template :style="dados.pessoa === 'j' ? 'width: 150px;' : 'width: 50%'" v-if="dados.pessoa === 'j'"
        :cpntTitulo="'IM'"
        :cpntValor="dados.im"
        :cpntCopiar="cpntTipo + '--' + 'im'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template v-if="dados.pessoa !== 'e'" :style="dados.pessoa === 'j' ? 'width: 150px;' : 'width: 50%'"
        :cpntTitulo="'IE'"
        :cpntValor="dados.ie"
        :cpntCopiar="cpntTipo + '--' + 'ie'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <template v-if="dados.pessoa === 'e'">
          <App-Visualizar-Cadastro-Dados-Template style="width: 200px;"
          :cpntTitulo="'Telefone'"
          :cpntValor="dados.tel_cel"
          :cpntCopiar="cpntTipo + '--' + 'tel_cel'"
          ></App-Visualizar-Cadastro-Dados-Template>

          <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 400px);" 
          :cpntTitulo="'E-mail'"
          :cpntValor="dados.email"
          :cpntCopiar="cpntTipo + '--' + 'email'"
          ></App-Visualizar-Cadastro-Dados-Template>
        </template>
      </div>

      <div class="linha" v-if="dados.pessoa !== 'e'">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 3);" v-if="dados.pessoa === 'j'"
        :cpntTitulo="'Optante Simples Nacional'"
        :cpntValor="dados.pj_sn === '0' ? 'Não' : 'Sim'"
        :cpntCopiar="cpntTipo + '--' + 'pj_sn'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 3);" v-else
        :cpntTitulo="'Telefone Residencial'"
        :cpntValor="dados.tel_res"
        :cpntCopiar="cpntTipo + '--' + 'tel_res'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 3);"
        :cpntTitulo="'Telefone Comercial'"
        :cpntValor="dados.tel_com"
        :cpntCopiar="cpntTipo + '--' + 'tel_com'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 3);"
        :cpntTitulo="'Telefone Celular'"
        :cpntValor="dados.tel_cel"
        :cpntCopiar="cpntTipo + '--' + 'tel_cel'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha" v-if="dados.pessoa !== 'e'">
        <App-Visualizar-Cadastro-Dados-Template
        :cpntTitulo="'Contato'"
        :cpntValor="dados.contato"
        :cpntCopiar="cpntTipo + '--' + 'contato'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha" v-if="dados.pessoa !== 'e'">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 2);"
        :cpntTitulo="'E-mail'"
        :cpntValor="dados.email"
        :cpntCopiar="cpntTipo + '--' + 'email'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% / 2);"
        :cpntTitulo="'Site'"
        :cpntValor="dados.site"
        :cpntCopiar="cpntTipo + '--' + 'site'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template v-if="dados.pessoa === 'e'" style="width: 200px;"
        :cpntTitulo="'Pais'"
        :cpntValor="dados.id_p_pais_xPais"
        :cpntCopiar="cpntTipo + '--' + 'id_p_pais_xPais'"
        :cpntImagem="'/img/bandeira/' + dados.id_p_pais_img + '.png'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template  style="width: calc(100% - 200px);"
        :cpntTitulo="dados.pessoa === 'e' ? 'Caixa Postal' : 'CEP'"
        :cpntValor="dados.cep"
        :cpntCopiar="cpntTipo + '--' + 'cep'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha" v-if="dados.pessoa !== 'e'">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 200px);"
        :cpntTitulo="'Estado'"
        :cpntValor="dados.id_estado_estado"
        :cpntCopiar="cpntTipo + '--' + 'id_estado_estado'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 200px;"
        :cpntTitulo="'Cidade'"
        :cpntValor="dados.id_cidade_cidade"
        :cpntCopiar="cpntTipo + '--' + 'id_cidade_cidade'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 200px);"
        :cpntTitulo="'Endereço'"
        :cpntValor="dados.end"
        :cpntCopiar="cpntTipo + '--' + 'end'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 200px;"
        :cpntTitulo="'Número'"
        :cpntValor="dados.num"
        :cpntCopiar="cpntTipo + '--' + 'num'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 200px);"
        :cpntTitulo="'Complemento'"
        :cpntValor="dados.comp"
        :cpntCopiar="cpntTipo + '--' + 'comp'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 200px;"
        :cpntTitulo="'Bairro'"
        :cpntValor="dados.bairro"
        :cpntCopiar="cpntTipo + '--' + 'bairro'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha" v-if="dados.pessoa !== 'e'">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 200px);"
        :cpntTitulo="'Observações'"
        :cpntValor="dados.obs"
        :cpntCopiar="cpntTipo + '--' + 'obs'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 200px;"
        :cpntTitulo="dados.pessoa === 'f' ? 'Data de Nascimento' : 'Data de Abertura'"
        :cpntValor="dados.aniv"
        :cpntCopiar="cpntTipo + '--' + 'aniv'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 200px);"
        :cpntTitulo="'Tipo de contato'"
        :cpntValor="dados.id_tp_con_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_tp_con_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 200px;" v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, [ 51 ], null, null, null, false) === true"
        :cpntTitulo="'Vendedor'"
        :cpntValor="dados.id_cms_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_cms_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template v-if="[ '', null, undefined ].indexOf(dados.updated_user) === -1"
        :cpntTitulo="'Última atualização'"
        :cpntValor='dados.updated_user_usuario + " [" + dados.updated_user + "] " + " em " + dados.updated_at_ptbr'
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <!-- ABRE VINCULO ENTRE CONTATOS -->
      <App-Contato-Vinculo-Tabela v-if="mostrarVinculo === true" class="cpnt-cad-vis-dados-vinculos" :cpntContatoId="Number(cpntRefId)"></App-Contato-Vinculo-Tabela>
    </template>

    <!-- VEICULO -->
    <template v-else-if="cpntTipo === 'veiculo'">
      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Proprietário'"
        :cpntValor="dados.id_con_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_con_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Placa'"
        :cpntValor="dados.placa"
        :cpntCopiar="cpntTipo + '--' + 'placa'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Marca'"
        :cpntValor="dados.id_mar_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_mar_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Modelo'"
        :cpntValor="dados.id_mod_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_mod_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Ano'"
        :cpntValor="dados.ano"
        :cpntCopiar="cpntTipo + '--' + 'ano'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Cor'"
        :cpntValor="dados.cor"
        :cpntCopiar="cpntTipo + '--' + 'cor'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Motor'"
        :cpntValor="dados.motor"
        :cpntCopiar="cpntTipo + '--' + 'motor'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Combustível'"
        :cpntValor="dados.combus"
        :cpntCopiar="cpntTipo + '--' + 'combus'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'KM'"
        :cpntValor="dados.km"
        :cpntCopiar="cpntTipo + '--' + 'km'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Observação'"
        :cpntValor="dados.obs"
        :cpntCopiar="cpntTipo + '--' + 'obs'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha"  v-if="[ '', null, undefined ].indexOf(dados.updated_user) === -1">
        <App-Visualizar-Cadastro-Dados-Template
        :cpntTitulo="'Última atualização'"
        :cpntValor='dados.updated_user_usuario + " [" + dados.updated_user + "] " + " em " + dados.updated_at_ptbr'
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>
    </template>

    <!-- VEICULO -->
    <template v-else-if="cpntTipo === 'pet'">
      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Proprietário'"
        :cpntValor="dados.id_con_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_con_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Nome'"
        :cpntValor="dados.nome"
        :cpntCopiar="cpntTipo + '--' + 'nome'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Espécie'"
        :cpntValor="dados.id_pet_especie_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_pet_especie_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Raça'"
        :cpntValor="dados.id_pet_subespecie_nome"
        :cpntCopiar="cpntTipo + '--' + 'id_pet_subespecie_nome'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Data Nascimento'"
        :cpntValor="dados.dt_nas_ptbr"
        :cpntCopiar="cpntTipo + '--' + 'dt_nas_ptbr'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Peso'"
        :cpntValor="dados.peso"
        :cpntCopiar="cpntTipo + '--' + 'peso'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Castrado'"
        :cpntValor="(dados.castrado === 's' ? 'Sim' : 'Não')"
        :cpntCopiar="cpntTipo + '--' + 'castrado'"
        ></App-Visualizar-Cadastro-Dados-Template>

        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Sexo'"
        :cpntValor="(dados.sexo === 'm' ? 'Masculino' : 'Feminino')"
        :cpntCopiar="cpntTipo + '--' + 'sexo'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha">
        <App-Visualizar-Cadastro-Dados-Template style="width: 50%;"
        :cpntTitulo="'Observação'"
        :cpntValor="dados.obs"
        :cpntCopiar="cpntTipo + '--' + 'obs'"
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>

      <div class="linha"  v-if="[ '', null, undefined ].indexOf(dados.last_at_ptbr) === -1">
        <App-Visualizar-Cadastro-Dados-Template
        :cpntTitulo="'Última atualização'"
        :cpntValor='dados.last_user_usuario + " [" + dados.last_user + "] " + " em " + dados.last_at_ptbr'
        ></App-Visualizar-Cadastro-Dados-Template>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .cpnt-cad-vis-dados {
    max-width: 645px;
    margin: 0px auto;
  }
  .cpnt-cad-vis-dados > .linha {
    width: 100%;
    vertical-align: top;
  }
    .cpnt-cad-vis-dados > .linha > div {
      padding: 2px 4px;
      vertical-align: top;
      display: inline-block;
      width: 100%;
    }

  .cpnt-cad-vis-dados-vinculos {
    margin: 5px 0px;  
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntRefId: {
        required: true,
        type: [ String, Number ]
      }
    },
    components: {
      'App-Visualizar-Cadastro-Dados-Template': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Dados-Template.vue'),
      'App-Contato-Vinculo-Tabela': () => import('@/components/contato/gerenciar/Contato-Vinculo-Tabela.vue')
    },
    data: function () {
      return {
        dados: null,
        mostrarVinculo: false
      }
    },
    mounted: function () {
      this.cpntVisualizarCadastroDadosIniciar()
    },
    methods: {
      cpntVisualizarCadastroDadosSetaStatusGeral: function (status) {
        this.$emit('SETAR_STATUS_GERAL', status)
      },
      cpntVisualizarCadastroDadosIniciar: function () {
        // FAZ A BUSCA DOS DADOS PARA O FORMULARIO
        this.cpntVisualizarCadastroDadosBuscarValores()

        // VERIFICA SE DEVE MOSTRAR O VINCULO ENTRE CONTATOS
        this.mostrarVinculo = this.cpntTipo === 'contato' && this.$store.state.configuracoes.contato.cfg_vinculo === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 100 ], null, false) === true
      },
      cpntVisualizarCadastroDadosBuscarValores: function () {
        // INICIA A VARIAVEL DA ROTA
        var route = ''
        var method = 'POST'

        // INICIA A VARIAVEL DO QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // VERIFICA A ROTA E OS CAMPOS QUE DEVE CHAMAR
        switch (this.cpntTipo) {
          case 'veiculo':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/veiculo/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // COMPLEMENTA O QUERY GET QUE VAI SER REALIZADO NO API
            queryGet = Object.assign(queryGet, { field: { id: null, id_con: { j: { nome: null } }, placa: null, id_mod: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } }, id_mar: { j: { nome: null } }, ano: null, cor: null, motor: null, combus: null, km: null, obs: null, status: null, updated_user: { j: { usuario: null } }, updated_at: null }, where: { f: 'id', o: '=', v: this.cpntRefId } })
            break

          case 'pet':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/pet/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // COMPLEMENTA O QUERY GET QUE VAI SER REALIZADO NO API
            queryGet = Object.assign(queryGet, { field: { id_con: { j: { nome: null, empresa: null, pessoa: null, status: null} }, id: null, nome: null, status: null, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome'}, id_especie: { j: { j_especie: { a: 'id_pet_especie_nome'} } } } }, peso: null, sexo: null, castrado: null, dt_nas: null, obs: null, last_at: null, last_user: { j: { usuario: null} } }, where: { f: 'id', o: '=', v: this.cpntRefId } })
            break

          case 'contato':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/contato/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // COMPLEMENTA O QUERY GET QUE VAI SER REALIZADO NO API
            queryGet = Object.assign(queryGet, { field: { id: null, nome: null, empresa: null, cnpj_cpf: null, ie: null, im: null, com_ind: null, rg: null, tel_res: null, tel_com: null, tel_cel: null, cargo: null, contato: null, email: null, site: null, id_p_pais: { j: { cPais: null, xPais: null, img: null } }, cep: null, id_estado: { j: { estado: null } }, id_cidade: { j: { cidade: null } }, end: null, num: null, comp: null, bairro: null, aniv: null, id_tp_con: { j: { nome: null } }, obs: null, pessoa: null, pj_sn: null, req: null, status: null, pf_nacionalidade: null, pf_est_civil: null, pf_empresa: null, pf_profissao: null, updated_user: { j: { usuario: null } }, updated_at: null, email_ctr: null, id_cms: { j: { nome: null, empresa: null, pessoa: null, status: null } } }, where: { f: 'id', o: '=', v: this.cpntRefId } })

            // // VERIFICA SE TEM O PACOTE COMISSÃO
            // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true) {
            //   queryGet.field.id_cms = null
            // }
            break
        }
        
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(route, method, queryGet, (apiSuccess) => {
          switch (this.cpntTipo) {
            case 'contato': {
              // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
              const FUN_FORMATAR_TELEFONE = require('@/assets/js/Funcoes-Gerais.js').FUN_FORMATAR_TELEFONE
  
              // FORMATA OS TELEFONES
              if ([ '', null, undefined ].indexOf(apiSuccess.data[0].tel_cel) === -1) {
                apiSuccess.data[0].tel_cel = FUN_FORMATAR_TELEFONE(apiSuccess.data[0].tel_cel)
              }
              if ([ '', null, undefined ].indexOf(apiSuccess.data[0].tel_com) === -1) {
                apiSuccess.data[0].tel_com = FUN_FORMATAR_TELEFONE(apiSuccess.data[0].tel_com)
              }
              if ([ '', null, undefined ].indexOf(apiSuccess.data[0].tel_res) === -1) {
                apiSuccess.data[0].tel_res = FUN_FORMATAR_TELEFONE(apiSuccess.data[0].tel_res)
              }
              break
            }

            case 'veiculo': {
              if ([ '', null, undefined ].indexOf(apiSuccess.data[0].ref_modelo) === -1) {
                // SETA O MODELO
                apiSuccess.data[0].id_mod = apiSuccess.data[0].ref_modelo
                apiSuccess.data[0].id_mod_nome = apiSuccess.data[0].ref_modelo_j_modelo

                // SETA A MARCA
                apiSuccess.data[0].id_mar = apiSuccess.data[0].ref_modelo_id_marca
                apiSuccess.data[0].id_mar_nome = apiSuccess.data[0].ref_modelo_id_marca_j_marca
              }

              // DELETA AS CHAVES NÃO UTILIZADAS
              delete apiSuccess.data[0].ref_modelo
              delete apiSuccess.data[0].ref_modelo_j_modelo
              delete apiSuccess.data[0].ref_modelo_id_marca
              delete apiSuccess.data[0].ref_modelo_id_marca_j_marca
              break
            }
          }

          // SETA OS DADOS RECEBIDOS
          this.dados = apiSuccess.data[0]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, this.cpntVisualizarCadastroDadosSetaStatusGeral)
      }
    }
  }
</script>
